import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'TruncateTextPipe' })
export class TruncateTextPipe implements PipeTransform {
  transform(value: string, maxLength: number): string {
    let newString = '';
    if (!value || value.length <= maxLength) {
      return value;
    }

    const truncatedValue = value.substr(0, maxLength);
    const lastPunctuationIndex = Math.max(truncatedValue.lastIndexOf(','), truncatedValue.lastIndexOf('.'));

    if (lastPunctuationIndex !== -1) {
      newString = truncatedValue.substr(0, lastPunctuationIndex) + ' ...';
    } else {
      newString = truncatedValue + ' ...';
    }

    return newString;
  }
}
